import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';

export const ColumnsSection = styled.div`
    height: 100%;
    padding-bottom: 3rem;

    @media ${MediaQueries.xlargeAndUp} {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: 100%;
    }
`;

export const Column = styled.div`
    display: grid;
    grid-template-rows: auto 1fr;
`;

export const ColumnHeader = styled.div`
    margin-top: 1rem;
    padding: 0 3rem;
`;

export const ColumnContent = styled.div`
    position: relative;
`;

export const ScrollableContent = styled.div`
    @media ${MediaQueries.xlargeAndUp} {
        position: absolute;
        inset: 0;
        overflow-y: auto;
    }
`;

export const ScrollableInnerContent = styled.div`
    margin: 0 3rem;
`;

export const TreeItemBar = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 0.5rem;
`;

export const TreeItemLabel = styled.div`
    overflow-wrap: break-word;
    hyphens: auto;
    white-space: normal;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    column-gap: 0.5rem;
`;

export const TreeItemActions = styled.div`
    display: flex;
    justify-content: end;
    column-gap: 0.5rem;
`;
